<template>
  <div class="dropdown ml-2" ref="dropdownWrapper" v-if="isLoggedIn">
    <button class="btn btn-secondary dropdown-toggle" @click.stop="toggleDropdown">
      Profile
    </button>

    <div class="dropdown-menu"
         v-if="showDropdown"
         style="display: block; position: absolute;">
      <button class="dropdown-item" @click="goToDetail">View Detail</button>
      <button class="dropdown-item" @click="deleteAccount">Delete Account</button>
      <button class="dropdown-item" @click="logout">Logout</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserProfileDropdown',
  data() {
    return {
      isLoggedIn: false,
      showDropdown: false,
      userId: null
    }
  },
  created() {
    this.checkLogin();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    checkLogin() {
      const token = localStorage.getItem('token');
      this.isLoggedIn = !!token;
      if (token) {
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          this.userId = payload.sub;
        } catch (e) {
          console.error('Token decoding error', e);
        }
      }
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    goToDetail() {
      this.showDropdown = false;
      this.$router.push({
        name: 'user.edit',
        params: { id: this.userId }
      });
    },
    async deleteAccount() {
      this.showDropdown = false;
      const result = await this.$swal.fire({
        title: "Are you sure?",
        text: "This will permanently delete your account!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        dangerMode: true
      });

      if (result.isConfirmed) {
        try {
          const token = localStorage.getItem('token');
          await this.$request.delete(`/users/${this.userId}`, {
            headers: { 'Authorization': 'Bearer ' + token }
          });
          
          localStorage.removeItem('token');
          this.isLoggedIn = false;
          this.$router.push('/login');
          this.$swal.fire('Deleted!', 'Your account has been deleted.', 'success');
        } catch (error) {
          console.error('Deletion failed', error);
          this.$swal.fire('Error!', 'Failed to delete account.', 'error');
        }
      }
    },
    logout() {
      localStorage.removeItem('token');
      this.isLoggedIn = false;
      this.showDropdown = false;
      this.$router.push('/login');
    },
    handleClickOutside(event) {
      if (this.$refs.dropdownWrapper && 
          !this.$refs.dropdownWrapper.contains(event.target)) {
        this.showDropdown = false;
      }
    }
  },
  watch: {
    '$route'() {
      this.checkLogin();
    }
  }
}
</script>